<template>
  <div class="Page">
    <span class="btn btn-prev entities pull-right" title="back" @click="router.go(-1)">&leftarrow;</span>
    <h1>Course</h1>
    <div v-if="SuccessMessage" class="alert alert-success">Course title has been saved</div>
    <div v-if="Error" class="alert alert-danger">{{ Error }}</div>
    <form @submit="onSubmit" class="col-md-4 mt-5 mr-auto ml-auto">
      <card headerBGColor="orange" title="Course">

        <vee-input
            name="title"
            type="text"
            :value="Course.title"
            inputClasses="no-border form-control-lg"
            placeholder="Title"
            :ref="refInputTitle"
            :key="Course.title"
        />

        <template v-slot:footer>
          <div class="text-center">
            <n-button native-type="submit" type="primary" :disabled="isSubmitting">
              Save
              <font-awesome-icon v-if="isSubmitting" class="loading" icon="arrows-rotate" />
            </n-button>
          </div>
        </template>

      </card>
    </form>
  </div>
</template>
<script>
import { VeeInput } from "@/components";
import { useForm } from "vee-validate";
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import * as Yup from "yup";

import apiCourses from '../../api/courses';

export default {
    name: "Course Modify",
    components: {
        VeeInput,
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const store = useStore();

        // Course Info
        let CourseID = typeof route.params.CourseID === 'undefined' ? 0 : parseInt(route.params.CourseID);
        let Course = computed(() => store.getters.Courses_GetByID(CourseID));
        if (CourseID && Course.value.id === 0) { store.dispatch('Courses_GetByID', CourseID); }

        // The Form
        let SuccessMessage = ref(false);
        let Error = ref('');
        let refInputTitle = ref(null);
        const schema = Yup.object().shape({
            title: Yup.string().required().label("The Course Title"),
        });
        const { handleSubmit, isSubmitting, setFieldError } = useForm({ validationSchema: schema });
        const onSubmit = handleSubmit (async values => {
            SuccessMessage.value = false;
            Error.value = '';
            if (CourseID)
            {
                apiCourses.Update(CourseID, values).then(res => {
                    Course.value.title = res.data.title;
                    store.dispatch('Courses_UpdateCourse', res.data);
                    SuccessMessage.value = true;
                }).catch(error => {
                  let ErrorCodes = [400, 500];
                  if (ErrorCodes.indexOf(error.response.status) > -1) { Error.value = 'Something went wrong. Try again later.'; }
                  if (error.response.status === 422) {
                    for (let x in error.response.data.errors) { setFieldError(x, error.response.data.errors[x][0]); }
                  }
                });
            }
            else
            {
                apiCourses.Add(values).then((response) => {
                    SuccessMessage.value = true;
                    router.push({name: 'Edit Course', params: {CourseID: response.data.id}});
                }).catch(error => {
                    let ErrorCodes = [400, 500];
                    if (ErrorCodes.indexOf(error.response.status) > -1) { Error.value = 'Something went wrong. Try again later.'; }
                    if (error.response.status === 422) {
                        for (let x in error.response.data.errors) { setFieldError(x, error.response.data.errors[x][0]); }
                    }
                });
            }
        });

        return {
            SuccessMessage,
            Error,
            onSubmit,
            isSubmitting,
            Course,
            router,
            refInputTitle
        };
    },
};
</script>
<style lang="scss">
.forgotpassword-page
{
    .logo-container { width: 65px; margin: 0 auto 55px; }
}
</style>